<template>
	<div class=''></div>
</template>

<script>
export default {
	name: '',
	data(){
		return {}
	},
	components: {},
	created(){},
	mounted(){},
	methods: {}
}
</script>
<style lang='scss' scoped>
</style>
